import React from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import styles from './WorkbenchField.css';
import TextSelect from './TextSelect.js';
import WorkbenchSelect from './WorkbenchSelect.js';
import WorkbenchMultiSelect from './WorkbenchMultiSelect';
import WorkbenchSentimentSelect from './WorkbenchSentimentSelect';

const SUBFIELD_TYPE_TEXTS = {
  Categorical: 'Multiple Values Allowed',
  Text: 'Multiple Values Allowed'
};

function renderSubFieldText(field) {
  const {
    multi,
    type
  } = field;
  const text = SUBFIELD_TYPE_TEXTS[type];

  if(text === undefined) {
    return null;
  }

  if(type === 'Categorical' && !multi) {
    return null;
  }

  return <p className={styles.subFieldText}>{text}</p>;
}

function WorkbenchField(props) {
  const {
    field,
    initiallySelectedTextValues,
    isFocused = false,
    isOpen = false,
    onSelectedTextChanged,
    focusNextField,
    focusPreviousField,
    ...other
  } = props;

  let inputComponent;
  if (field.type === 'Text') {
    const initiallyAppliedValues = filter(initiallySelectedTextValues, { workbenchFieldId: field.id });
    inputComponent = (
      <TextSelect
        {...other}
        field={field}
        onTextChanged={onSelectedTextChanged}
        isOpen={isOpen}
        initiallyAppliedValues={initiallyAppliedValues}
        focusNextField={focusNextField}
        focusPreviousField={focusPreviousField}
      />
    );
  }
  else if (field.type === 'Sentiment') {
    inputComponent = (
      <WorkbenchSentimentSelect
        {...other}
        isFocused={isFocused}
        disabled={!!field.disabled}
        disabledTooltip={field.disabled ? <span>Sentiment overrides are disabled<br />for Curated Datasets.</span> : undefined}
      />
    );
  }
  else if (field.multi) {
    inputComponent = (
      <WorkbenchMultiSelect
        {...other}
        values={field.values}
        isFocused={isFocused}
        isOpen={isOpen}
      />
    );
  }
  else {
    inputComponent = (
      <WorkbenchSelect
        {...other}
        values={field.values}
        isFocused={isFocused}
        isOpen={isOpen}
      />
    );
  }

  const labelClass = `label${field.type}`;
  const valueClass = `value${field.type}`;
  const containerClass = field.disabled ? styles.containerDisabled : (isFocused ? styles.focusedContainer : styles.container);

  return (
    <div
      tabIndex="0"
      className={containerClass}
    >
      <div className={styles[labelClass]}>
        <p className={styles.name}>{field.name}</p>
        {isFocused ? renderSubFieldText(field) : null}
      </div>
      <div className={styles[valueClass]}>
        {inputComponent}
      </div>
    </div>
  );

}


WorkbenchField.propTypes = {
  field: PropTypes.object.isRequired,
  initiallySelectedTextValues: PropTypes.array,
  isFocused: PropTypes.bool,
  isOpen: PropTypes.bool,
  onSelectedTextChanged: PropTypes.func,
  focusNextField: PropTypes.func,
  focusPreviousField: PropTypes.func
};

export default WorkbenchField;
